<div class="row">
    <div class="col-md-12">
        <h2>Exam Ralated Issue Detail</h2>


        <table>
            <tr>
                <th>Ticket Id</th>
                <td>{{this.trackId_refno}} </td>
            </tr>
            <tr>
                <th>Nature of Technical Issue Faced</th>
                <td>{{this.trackId_ntef}} </td>
            </tr>
            <tr>
                <th>Issue detail</th>
                <td>{{this.trackId_issuedetail}} </td>
            </tr>
            <tr>
                <th>Description</th>
                <td>{{this.trackId_description}} </td>
            </tr>
            <tr>
                <th>ITI code</th>
                <td>{{this.trackId_iticode}} </td>
            </tr>
            <tr>
                <th>Trade</th>
                <td>{{this.trackId_trade}} </td>
            </tr>
            <tr>
                <th>Ticket Id</th>
                <td>{{this.trackId_center}} </td>
            </tr>
            <tr>
                <th>Date</th>
                <td>{{this.trackId_date}} </td>
            </tr>
            <tr>
                <th>State</th>
                <td>{{this.trackId_state}} </td>
            </tr>
            <tr>
                <th>District</th>
                <td>{{this.trackId_district}} </td>
            </tr>
            <tr>
                <th>Shift</th>
                <td>{{this.trackId_shift}} </td>
            </tr>
            <tr>
                <th>Attendance</th>
                <td>{{this.trackId_attendance}} </td>
            </tr>
            <tr>
                <th>Invigilator Name</th>
                <td>{{this.trackId_inviginame}} </td>
            </tr>
            <tr>
                <th>Status</th>
                <td>{{this.trackId_status}} </td>
            </tr>
            <tr>
                <th>Your Status</th>
                <td>{{this.trackId_admin_status}} </td>
            </tr>
            <tr>
                <th>Your Description</th>
                <td>{{this.trackId_admin_status_desc}} </td>
            </tr>



        </table>

    </div>
</div>